import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useRef } from "react";
import Loading from "../../../../../../components/Loading/Loading";
import localeText from "../../../../../../locale";
import { formatDateTime } from "../../../../../../utilities/formatDate";
import useChat from "../../hooks/useChat";
import "./style.css";

const Triangle = ({ left = true }) => {
  return (
    <div
      className="triangleChat absolute "
      style={left ? { left: "-7px" } : { right: "-7px" }}
      id={left ? "triangulo-para-esquerda" : "triangulo-para-direita"}
    />
  );
};

const ChatModal = ({ isVisible, setNotVisibleChat, currentOrder }) => {
  const chatContainer = useRef(null);
  const {
    messages,
    sendMessage,
    setMessage,
    message,
    isLoadingSendMessage,
    isLoadingGetMessages,
    isLoadingRetryGet,
    hasError,
  } = useChat({
    idorder: currentOrder?.id,
  });

  const myUsername = localStorage.getItem("__extraconomy_username");

  const talkTo =
    myUsername === currentOrder?.buyer?.username
      ? currentOrder?.seller?.firstname
      : currentOrder?.buyer?.firstname;

  const messageReceiver =
    talkTo === currentOrder?.buyer?.firstname
      ? currentOrder?.buyer?.username
      : currentOrder?.seller?.username;

  useEffect(() => {
    if (isVisible && chatContainer?.current && !isLoadingGetMessages && !isLoadingRetryGet) {
      chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
    }
  }, [chatContainer, isVisible, messages, isLoadingGetMessages, isLoadingRetryGet]);

  useEffect(() => {
    return () => setMessage("");
  }, [setMessage]);

  return (
    <Dialog
      header={`${localeText("talkTo")} ${talkTo}`}
      visible={isVisible}
      onHide={() => {
        if (!isLoadingSendMessage) setNotVisibleChat();
      }}
      draggable={false}
      breakpoints={{ "960px": "85vw" }}
      style={{ width: "50vw" }}
    >
      {isLoadingGetMessages ? (
        <div className="flex justify-content-center align-items-center" style={{ height: "40vh" }}>
          <Loading disableMargin />
        </div>
      ) : (
        <>
          {hasError ? (
            <div
              style={{ height: "40vh" }}
              className="flex justify-content-center align-items-center text-center"
            >
              <p>{localeText("serverError")}</p>
            </div>
          ) : (
            <div style={{ height: "40vh", overflowY: "auto" }} ref={chatContainer}>
              <div className="flex flex-column justify-content-end">
                {messages?.length === 0 ? (
                  <div className="w-full h-full flex justify-content-center align-items-center">
                    <span>{localeText("noMessages")}</span>
                  </div>
                ) : (
                  <>
                    {messages?.map((message) => (
                      <div
                        key={message?.id}
                        className={`flex flex-column mb-2 ${
                          message?.userFrom?.username === myUsername
                            ? "align-items-end"
                            : "align-items-start"
                        }`}
                        style={
                          message?.userFrom?.username === myUsername
                            ? { marginRight: "7px" }
                            : { marginLeft: "7px" }
                        }
                      >
                        <div className="bg-gray-200 p-2 border-round relative z-1">
                          <div className="flex flex-column">
                            <span className="font-bold">{message?.userFrom?.firstname}</span>
                            <span
                              style={{
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                                wordWrap: "break-word",
                              }}
                            >
                              {message?.message}
                            </span>
                          </div>
                          <span className="text-xs text-left">
                            {formatDateTime(message?.datetimeMessage)}{" "}
                            {message?.visualized ? (
                              <i className="text-xs pi pi-check-circle" />
                            ) : (
                              <i className="text-xs pi pi-check" />
                            )}
                          </span>
                          <span>
                            <Triangle left={!(message?.userFrom?.username === myUsername)} />
                          </span>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </>
      )}
      {!isLoadingGetMessages && isLoadingRetryGet && (
        <span className="block w-full text-center">
          <Loading disableMargin />
        </span>
      )}
      <div className="w-full flex align-items-center gap-2 mt-2">
        <InputTextarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full"
          style={{ resize: "none" }}
        />
        <Button
          onClick={() => sendMessage({ userTo: messageReceiver })}
          loading={isLoadingSendMessage}
          disabled={message?.length === 0}
          className={message?.length === 0 ? "opacity-70 px-4 py-3" : "px-4 py-3"}
          icon="pi pi-send"
        />
      </div>
    </Dialog>
  );
};

export default ChatModal;
